<template>
    <div class="row">
        <div class="cols-12 col-md-6 col-lg-4 mb-5"
             v-for="(section,index) in courseLecture"
             :key="index"
        >
            <b-card :img-src=section.lecture_cover
                    img-alt="Image"
                    img-top
                    img-width="350"
                    img-height="200"
                    tag="article"
                    class="h-100"
            >
                <b-card-body>
                    <b-card-title>
                        <h5>
                            {{ section.lecture_title }}
                        </h5>
                    </b-card-title>
                </b-card-body>
                <div slot="footer">
                    <div class="d-flex align-items-center">
                        <b-button variant="link"
                                  pill
                                  block
                                  sm
                                  @click="showLectureVideo(section.lecture_id)"
                                  class="lecture-btn d-flex justify-content-center align-items-center"
                        >
                            <i class="fab fa-youtube" style="margin: 0 1rem; font-size: 35px; color: red"></i>
                            <span class="h-100" style="color: #573c81">
                            รับชมบทเรียน
                        </span>
                        </b-button>
                    </div>
                </div>
            </b-card>

            <b-modal :id="`lecture-video-modal-${section.lecture_id}`"
                     centered
                     size="xl"
                     no-close-on-backdrop
                     no-close-on-esc
                     :hide-footer=true
                     :title=section.lecture_title
            >
                <iframe :src="section.media_src"
                        frameborder="0"
                        style="overflow:hidden;height:80vh;width:100%"
                        height="100%"
                        width="100%"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
            </b-modal>
        </div>

        <b-modal v-if="evaluateQuestions.length > 0"
                 id="lecture-evaluate"
                 scrollable
                 centered
                 size="lg"
                 ok-only
                 ok-title="ตกลง"
                 :title="lectureProgressTitle">
            <b-row v-for="(evaluate,index) in evaluateQuestions" :key="index"
                   d-flex
                   class="mb-2"
            >
                <b-col cols="2" class="m-auto">
                    <h5>{{ evaluate.evaluate.code }}</h5>
                </b-col>
                <b-col cols="8">
                    <strong>{{ evaluate.evaluate.title }}</strong>
                    <b-progress :value="parseFloat(evaluate.value)"></b-progress>
                </b-col>
                <b-col cols="2" class="m-auto">
                    <h5>{{ evaluate.value }} %</h5>
                </b-col>
            </b-row>
        </b-modal>

    </div>

</template>

<script>
    import Service from "../../services";
    import StudyChapter from "./StudyChapter";
    import BButton from "bootstrap-vue/src/components/button/button";
    import {mapGetters} from "vuex";

    export default {
        name: "CourseStudy",
        props: ['courseLecture'],
        components: {
            BButton,
            StudyChapter
        },
        data() {
            return {
                courseCode: this.$route.params.id,
                section: {
                    lecture_title: null,
                    media_src: null
                },
                lectureProgressTitle: null,
                evaluateQuestions: []

            }
        },
        created() {

        },
        watch: {
            'courseLecture'() {
                //force click first chapter when selected course study
                this.switchChapter(this.courseLecture[0]);
            }
        },
        computed: {
            // mix the getters into computed with object spread operator
            ...mapGetters({
                user: "Auth/getUser"
            })
        },
        methods: {
            showLectureVideo(lecture_id) {
                this.$bvModal.show(`lecture-video-modal-${lecture_id}`);
                setTimeout(function () {
                    Service.course.saveUserViewCourseLecture({
                        lecture_id: lecture_id
                    })
                        .then((res) => {
                            console.log(res)
                        })
                }, 15000);
            },
            switchChapter(section) {
                this.section = section;
                this.$root.$emit('bv::show::modal', 'lecture-video-modal')
            },
            goToQuestion(section, questionSet) {

                if (this.user === null) {
                    this.$toasted.show("Please login.", {
                        type: 'error',
                        icon: 'exclamation-circle',
                        iconPack: 'fontawesome',
                        duration: 5000
                    });
                } else {
                    this.$router.push({
                        name: 'lecture-question',
                        params: {
                            id: section.course_code,
                            lecture: section,
                            question_set_id: questionSet
                        }
                    })
                }

            },
            initModelPregressBar(lectureTitle, lectureEvaluate) {
                this.lectureProgressTitle = lectureTitle
                this.evaluateQuestions = lectureEvaluate
            }
        }

    }
</script>

<style scoped>
    .lecture-question {
        color: #37414a !important;
    }

    .lecture-title {
        color: #573c81 !important;
        padding: 0 !important;
        font-size: 18px;
    }

    .lecture-btn {
        text-decoration: none;
        color: #573c81;
    }
</style>